/* @flow */
import React from 'react'
import Modal from 'react-modal'

import './index.styl'
import './styles.css'

const CLOSE_TIMEOUT = 500

export type Props = {
  isOpen: boolean,
  title?: any,
  onRequestClose?: Function,
  onAfterOpen?: Function,
  children: any,
  className?: string,
  overlayClassName?: string,
  from?: 'left' | 'right',
  width?: string
}

export default function ReactSlidingPane(props: Props) {
  const {
    isOpen,
    title,
    onRequestClose,
    onAfterOpen,
    children,
    className,
    overlayClassName,
    from = 'right',
    width
  } = props

  const directionClass = `slide-pane_from_${from}`
  return (
    <Modal
      className={`slide-pane ${directionClass} ${className || ''}`}
      style={{ content: { width: width || '90%' } }}
      overlayClassName={`slide-pane__overlay ${overlayClassName || ''}`}
      closeTimeoutMS={CLOSE_TIMEOUT}
      isOpen={isOpen}
      onAfterOpen={onAfterOpen}
      onRequestClose={onRequestClose}
      contentLabel={`Modal "${title || ''}"`}
    >
      <div className='slide-pane__header' onClick={onRequestClose}>
        <div className='slide-pane__title-wrapper'>
          <h3 className='slide-pane__title ui tiny header'>{title}</h3>
        </div>
        <div className='slide-pane__close'>
          <div className='closer-text'>Schliessen</div>
          <i className='close icon' />
        </div>
      </div>
      <div className='slide-pane__content' onClick={onRequestClose}>
        {children}
      </div>
    </Modal>
  )
}
